import {
  addRecentBackground,
  initializeCategoryDict,
  initializeCommonTemplateDict,
  initializeSpecialTemplateDict,
  selectCategory,
  selectTemplate,
} from './actions';

import { TemplateType } from './constants';
import { createReducer } from '@reduxjs/toolkit';

export const categoryDictReducer = createReducer({}, (builder) => {
  builder
    .addCase(initializeCategoryDict, (state, action) => {
      Object.assign(state, action.payload);
    })
    .addCase(selectCategory, (state, action) => {
      const { imprintAreaKey, categoryId } = action.payload;
      const categories = Object.keys(state).includes(imprintAreaKey) ? state[imprintAreaKey] : [];
      categories.forEach((category) => (category.isSelected = category.categoryId === categoryId));
    });
});

export const commonTemplateDictReducer = createReducer({}, (builder) => {
  builder
    .addCase(initializeCommonTemplateDict, (state, action) => {
      Object.assign(state, action.payload);
    })
    .addCase(selectTemplate, (state, action) => {
      const { imprintAreaKey, categoryId, templateId } = action.payload;
      const templateDict = Object.keys(state).includes(imprintAreaKey) ? state[imprintAreaKey] : {};
      const templates = Object.values(templateDict).flat();
      templates.forEach(
        (template) => (template.isSelected = template.categoryId === categoryId && template.templateId === templateId)
      );
    });
});

export const specialTemplateDictReducer = createReducer({}, (builder) => {
  builder
    .addCase(initializeSpecialTemplateDict, (state, action) => {
      Object.assign(state, action.payload);
    })
    .addCase(selectTemplate, (state, action) => {
      const { imprintAreaKey, categoryId, templateId } = action.payload;
      const templates = Object.keys(state).includes(imprintAreaKey) ? state[imprintAreaKey] : [];
      templates.forEach(
        (template) => (template.isSelected = template.categoryId === categoryId && template.templateId === templateId)
      );
    });
});
const recentBackgroundDict = createReducer({}, (builder) => {
  builder.addCase(addRecentBackground, (state, action) => {
    const { imprintAreaKey, background } = action.payload;
    state[imprintAreaKey] = state[imprintAreaKey] || [];
    //only for common and custom
    if (
      !state[imprintAreaKey].some((x) =>
        background.templateType === TemplateType.CUSTOM
          ? x.originFileName === background.originFileName
          : x.templateId === background.templateId
      )
    )
      state[imprintAreaKey].unshift(background);
  });
});

const templateReducer = {
  categoryDict: categoryDictReducer,
  templateDict: commonTemplateDictReducer,
  specialTemplateDict: specialTemplateDictReducer,
  recentBackgroundDict,
};

export default templateReducer;
